import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../utils/config.service';

@Injectable()
export class AddimageService {
    private readonly getConfigURL = `${environment.API}${environment.RESOURCES.ADD_IMAGE}`;
    private readonly signatureUrl = `${environment.API}${environment.RESOURCES.SIGNATURES}`;
    private readonly canvasTouchedMap = new Map<string, boolean>();

    constructor(private readonly http: HttpClient, private readonly configService: ConfigService) {
        this.getConfigURL = `${configService.getBaseApiUrl}${environment.RESOURCES.ADD_IMAGE}`;
        this.signatureUrl = `${configService.getBaseApiUrl}${environment.RESOURCES.SIGNATURES}`;
    }


    uploadFile(fileToUpload: any, filename: string, folder: string, url: string): Promise<Object> {
        if (!(fileToUpload instanceof File)) {
            console.error('El fitxer proporcionat no és vàlid.');
            return Promise.reject('El fitxer proporcionat no és vàlid.');
        }
        const formData = new FormData();
        formData.append('file', fileToUpload, filename);
        formData.append('carpeta_imatges', folder);
        formData.append('base_url_imatges', url);
        return this.http.post(this.getConfigURL, formData)
            .toPromise()
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

    public setCanvasMapEntry(key: string, value: boolean) {
        this.canvasTouchedMap.set(key, value);
    }

    public getCanvasTouched(key: string): boolean {
        return this.canvasTouchedMap.get(key);
    }

    deleteSignature(encoded: string) {
        return this.http.delete(`${this.signatureUrl}?encoded=${encodeURIComponent(encoded)}`);
    }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/data/addimage.service.ts